/* eslint-disable no-unused-expressions */
import axios, { AxiosResponse } from 'axios'
import { toastFailed, toastFailedBig } from 'utils/toast'
import { decodeAll } from 'utils/helpers/decodeAll'

const DEFAULT_ERROR_MESSAGE = 'Something went wrong, please try again.'

export const getErrorMessage = (error: unknown, defaultMessage?: string): string => {
  const fallback = defaultMessage || DEFAULT_ERROR_MESSAGE

  if (axios.isAxiosError(error)) {
    const data = error.response?.data
    return data?.error?.message || data?.message || (defaultMessage ?? error.message) || fallback
  }

  if (error instanceof Error) {
    return error.message || fallback
  }

  return fallback
}

/**
 *
 * @param {AxiosResponse} errorResponse
 */
export const getParsedErrorResponse = (errorResponse: AxiosResponse) => {
  const message =
    errorResponse?.data?.error?.message ||
    errorResponse?.data?.error?.msg ||
    errorResponse?.data?.message ||
    errorResponse?.data?.error_message

  return message || `Failed with status code ${errorResponse.status}`
}

const showToastMessage = (
  message: string,
  toastOptions: { big?: boolean; autoClose?: boolean; decode?: boolean } | undefined,
) => {
  toastOptions?.big ? toastFailedBig(message) : toastFailed(message, toastOptions)
}

export const callErrorMsg = (
  resError: unknown,
  defaultError?: string,
  toastOptions?: { big?: boolean; autoClose?: boolean; decode?: boolean },
) => {
  // Fix: Ensure resError is typed as possibly AxiosError, and safely access .response
  const errorResponse =
    resError && typeof resError === 'object' && 'response' in resError
      ? (resError as { response?: AxiosResponse }).response
      : undefined

  if (errorResponse) {
    const errorMessage = getParsedErrorResponse(errorResponse)
    let message = errorMessage
    if (toastOptions?.decode) {
      message = decodeAll(message)
    }

    const fallbackMessage = defaultError || `Failed with status code ${errorResponse.status}`
    showToastMessage(message || fallbackMessage, toastOptions)
  } else if (defaultError) {
    showToastMessage(defaultError, toastOptions)
  }
}
